export default __webpack_public_path__ + "static/media/gothenburg_background_s2.126af362.jpg";